module.exports = __webpack_public_path__ + "img/744.a4ecd9ad.jpg";